import file_button from './file_button.vue'
const FileButton = {
  install: function (Vue) {
    Vue.component('FileButton', file_button)
  }
}
export default FileButton
